export const BZ_CONTACT_PHONE = '1 (877) 440-9464';
export const BZ_CONTACT_PHONE_HREF = 'tel:+18774409464';
export const BZ_CONTACT_EMAIL = 'verify@benzinga.com';
export const NBSP = '\xa0';
export const NO_VALUE = '--';
export const PRODUCT_FEEDBACK = 'https://portal.prodpad.com/25266';
